import { render, staticRenderFns } from "./FormSelected.vue?vue&type=template&id=81bf1b7a"
import script from "./FormSelected.vue?vue&type=script&lang=js"
export * from "./FormSelected.vue?vue&type=script&lang=js"
import style0 from "./FormSelected.vue?vue&type=style&index=0&id=81bf1b7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports